import React, { useEffect, useMemo, useState } from 'react';
import { Formik } from 'formik';
import { isEqual } from 'lodash';
import { useReconcileUIContext } from '../ReconcileUIContext';
import { initialFilter } from '../ReconcileUIHelpers'
import { getFundtypeAll } from "../../../../MasterData/_redux/fund_type/fundtypeCrud";
import { getBankAll } from "../../../../MasterData/_redux/bank/bankCrud";
import { DateRangePicker } from 'react-dates';
import moment from 'moment'
import { getBranchAll } from '../../../../MasterData/_redux/branchs/branchCrud'
import CurrencyInput from 'react-currency-input-field';
import { getBankPoolingAll } from '../../../../MasterData/_redux/bank-pooling/bankPoolingCrud';
import Autocomplete from '@material-ui/lab/Autocomplete';
import TextField from '@material-ui/core/TextField';
import { getBankAccountAll } from '../../../../MasterData/_redux/bank-account/bankAccountCrud';



const prepareFilter = (queryParams, values) => {
    const {
        reconcile_hid,
        start_date,
        end_date,
        branch,
        bank,
        bank_account_uuid,
        amountgt,
        amountlt,
        channel_chargelt,
        channel_chargegt,
        date,
    } = values;
    const newQueryParams = { ...queryParams };
    const filter = {};

    //add to Object filter
    filter.reconcile_hid = reconcile_hid ?? '';
    filter.start_date = start_date ?? '';
    filter.end_date = end_date ?? '';
    filter.branch = branch ?? ''
    filter.bank = bank ?? ''
    filter.bank_account_uuid = bank_account_uuid ?? ''
    filter.amountgt = amountgt ?? ""
    filter.amountlt = amountlt ?? ""
    filter.channel_chargegt = channel_chargegt ?? ""
    filter.channel_chargelt = channel_chargelt ?? ""
    filter.date = date ?? ""


    newQueryParams.filter = filter;
    return newQueryParams;
};

export const ReconcileFilter = () => {

    const reconcileUIContext = useReconcileUIContext();
    const reconcileUIProps = useMemo(() => {
        return {
            setQueryParams: reconcileUIContext.setQueryParams,
            queryParams: reconcileUIContext.queryParams,
            filterType: reconcileUIContext.filterType,
        };
    }, [reconcileUIContext]);


    // USE STATE
    const [bankList, setBankList] = useState([]);
    const [branchList, setBranchList] = useState([])
    const [kodeRek, setKodeRek] = useState([]);
    const [typeDona, setTypeDona] = useState([]);
    const [bankPoolingList, setBankPoolingList] = useState([])
    const [bankPoolingListFiltered, setBankPoolingListFiltered] = useState([])
    const [showRekeningField, setShowRekeningField] = useState(false)
    const [onFocused, setOnFocused] = useState(null)
    const [tanggal, setTanggal] = useState(
        {
            start_date: null,
            end_date: null,
        }
    )

    const [bankAccountOption, setBankAccountOption] = useState([])

    const applyFilter = (values) => {
        const newQueryParams = prepareFilter(reconcileUIProps.queryParams, values);
        if (!isEqual(newQueryParams, reconcileUIProps.queryParams)) {
            newQueryParams.pageNumber = 1;
            reconcileUIProps.setQueryParams(newQueryParams);
        }
    };

    const fetchType = async () => {
        const result = await getFundtypeAll();
        setTypeDona(result.data.data);
    };

    const fetchBank = async () => {
        const result = await getBankAll();
        setBankList(result.data.data);
    };
    const fetchBankPooling = async () => {
        const result = await getBankPoolingAll();
        setBankPoolingList(result.data.data);
        setBankPoolingListFiltered(result.data.data)
    };

    const fetchBranch = async (value) => {
        const result = await getBranchAll()
        setBranchList(result.data.data)
    }

    const setBankPoolingBranch = (value, bank_values, setFieldValue) => {
        if (value === "") {
            if (bank_values === "") {
                setFieldValue('bank_pooling_uuid', '')
                setBankPoolingListFiltered(bankPoolingList)
            } else {
                let obj = bankPoolingList.filter(object => object.bank_uuid === bank_values)
                setBankPoolingListFiltered(obj)
            }

        } else {
            if (bank_values === "") {
                setFieldValue('bank_pooling_uuid', '')
                let obj = bankPoolingList.filter(object => object.branch_uuid === value)
                setBankPoolingListFiltered(obj)
            } else {
                setFieldValue('bank_pooling_uuid', '')
                let obj = bankPoolingList.filter(object => object.branch_uuid === value && object.bank_uuid === bank_values)
                setBankPoolingListFiltered(obj)
            }

        }
    }

    const setBankPoolingBank = (value, branch_value, setFieldValue) => {
        if (value === "") {
            if (branch_value === "") {
                setFieldValue('bank_pooling_uuid', '')
                setBankPoolingListFiltered(bankPoolingList)
            } else {
                setFieldValue('bank_pooling_uuid', '')
                let obj = bankPoolingList.filter(object => object.branch_uuid === branch_value)
                setBankPoolingListFiltered(obj)
            }

        } else {
            if (branch_value === "") {
                setFieldValue('bank_pooling_uuid', '')
                let obj = bankPoolingList.filter(object => object.bank_uuid === value)
                setBankPoolingListFiltered(obj)
            } else {
                setFieldValue('bank_pooling_uuid', '')
                let obj = bankPoolingList.filter(object => object.bank_uuid === value && object.branch_uuid === branch_value)
                setBankPoolingListFiltered(obj)
            }

        }
    }

    useEffect(() => {
        fetchType();
        fetchBankPooling();
        fetchBank();
        fetchBranch()
        getBankAccount();
        // eslint-disable-next-line
    }, []);

    const getBankAccount = () => {
        getBankAccountAll().then(res => setBankAccountOption(res.data.data))
    }

    return (
        <Formik initialValues={initialFilter.filter} onSubmit={(values) => {
            applyFilter(values);
            // console.log(values)
        }}
        >
            {({ values, handleSubmit, handleBlur, setFieldValue, resetForm }) => (
                <form onSubmit={handleSubmit} className="form form-label-right">

                    <div className="form-group row">
                        <div className="col-lg-4">
                            <DateRangePicker
                                small={true}
                                startDate={tanggal.start_date}
                                endDate={tanggal.end_date}
                                onDatesChange={({ startDate, endDate }) => {
                                    setTanggal({
                                        start_date: startDate,
                                        end_date: endDate
                                    })
                                    setFieldValue('start_date', startDate)
                                    setFieldValue('end_date', endDate)
                                }}
                                focusedInput={onFocused}
                                onFocusChange={focusedInput => setOnFocused(focusedInput)}
                                numberOfMonths={1}
                                isOutsideRange={() => false}
                                showClearDates={true}
                                startDateId="start_date"
                                endDateId="end_date"
                                hideKeyboardShortcutsPanel={true}
                            />
                            <small className="form-text text-muted">
                                <b>Cari</b> Berdasarkan Rentan Waktu
                            </small>
                        </div>
                        <div className="col-lg-4">
                            <TextField
                                id="date"
                                type="date"
                                name="date"
                                className="form-control"
                                onChange={(e) => {
                                    setFieldValue('date', e.target.value)

                                }}
                            />
                            <small className="form-text text-muted">
                                <b>Cari</b> Berdasarkan Harian
                            </small>

                        </div>
                        <div className="col-lg-4">
                            <input
                                type="text"
                                className="form-control"
                                name="reconcile_hid"
                                placeholder="Search"
                                onBlur={handleBlur}
                                value={values.reconcile_hid}
                                onChange={(e) => {
                                    setFieldValue('reconcile_hid', e.target.value);
                                }}
                            />
                            <small className="form-text text-muted">
                                <b>Cari</b> Konfirmasi HID
                            </small>
                        </div>

                    </div>

                    {/*ROW 1 BY DONATUR*/}
                    <div className="form-group row">

                        {/*ROW 2*/}


                        {/* <div className="col-lg-4">
                            <select
                                className="form-control"
                                placeholder="Nama Cabang"
                                name="branch"
                                onBlur={handleBlur}
                                onChange={(e) => {
                                    setFieldValue('branch', e.target.value);
                                    setBankPoolingBranch(e.target.value, values.bank, setFieldValue)

                                }}
                                value={values.branch}
                            >
                                <option value=''>ALL</option>
                                {branchList.map(list =>
                                    <option key={list.uuid} value={list.uuid}>{list.name}</option>,
                                )}
                            </select>
                            <small className="form-text text-muted">
                                Cari <b>Cabang</b>
                            </small>
                        </div> */}
                        <div className="col-lg-4">
                            <select
                                className="form-control"
                                value={values.bank}
                                name="bank" onChange={(e) => {
                                    setBankPoolingBank(e.target.value, values.branch, setFieldValue)

                                }}>
                                <option value="">--PILIH--</option>
                                {bankList.map(item =>
                                    <option key={item.uuid} value={item.uuid}>{item.name}</option>,
                                )}
                            </select>
                            <small className="form-text text-muted">
                                <b>Cari</b> Bank
                            </small>
                        </div>
                        <div className="col-lg-4">
                            {/* <select
                                className="form-control"
                                name="echannel" onChange={(e) => {
                                    setFieldValue('echannel', e.target.value)

                                }}>
                                <option value="">ALL</option>
                                {echannelKurbanList.map(item =>
                                    <option key={item.uuid} value={item.uuid}>{item.name}</option>,
                                )}
                            </select> */}
                            <Autocomplete
                                name="bank_account_uuid"
                                options={bankAccountOption}
                                getOptionLabel={(option) => option.account_number}
                                onChange={(e, value) => {
                                    if (value) {
                                        setFieldValue("bank_account_uuid", value.uuid)
                                    } else {
                                        setFieldValue("bank_account_uuid", "")
                                    }
                                }}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        placeholder="Cari Rekening"
                                        variant="outlined"
                                        disableClearable
                                        size="small"

                                    />
                                )}
                            />
                            <small className="form-text text-muted">
                                <b>Cari</b> Rekening
                            </small>
                        </div>

                    </div>

                    <div className="form-group row">
                        <div className="col-lg-4">

                            <CurrencyInput
                                name="amountgt"
                                placeholder="Nominal Lebih dari"
                                intlConfig={{ locale: 'id-ID', currency: 'IDR' }}
                                className="form-control"
                                // defaultValue={values.goods_qty_price ?? ""}
                                value={values.amountgt}
                                decimalsLimit={2}
                                label="Jumlah"
                                onValueChange={(value, name) => {
                                    setFieldValue(name, value)

                                }}
                            />
                            <small className="form-text text-muted">
                                <b>Cari</b> Nominal Lebih Dari
                            </small>
                        </div>
                        <div className="col-lg-4">

                            <CurrencyInput
                                name="amountlt"
                                placeholder="Nominal Kurang Dari"
                                intlConfig={{ locale: 'id-ID', currency: 'IDR' }}
                                className="form-control"
                                // defaultValue={values.goods_qty_price ?? ""}
                                value={values.amountlt}
                                decimalsLimit={2}
                                label="Jumlah"
                                onValueChange={(value, name) => {
                                    setFieldValue(name, value)
                                }}
                            />
                            <small className="form-text text-muted">
                                <b>Cari</b> Nominal Kurang Dari
                            </small>
                        </div>

                    </div>
                    <div className="form-group row">
                        <div className="col-lg-4">

                            <CurrencyInput
                                name="channel_chargegt"
                                placeholder=" Selisih Nominal Lebih Dari"
                                intlConfig={{ locale: 'id-ID', currency: 'IDR' }}
                                className="form-control"
                                // defaultValue={values.goods_qty_price ?? ""}
                                value={values.channel_chargegt}
                                decimalsLimit={2}
                                label="Jumlah"
                                onValueChange={(value, name) => {
                                    setFieldValue(name, value)

                                }}
                            />
                            <small className="form-text text-muted">
                                <b>Cari</b> Selisih Nominal Lebih Dari
                            </small>
                        </div>
                        <div className="col-lg-4">

                            <CurrencyInput
                                name="channel_chargelt"
                                placeholder="Selisih Nominal Kurang Dari"
                                intlConfig={{ locale: 'id-ID', currency: 'IDR' }}
                                className="form-control"
                                // defaultValue={values.goods_qty_price ?? ""}
                                value={values.channel_chargelt}
                                decimalsLimit={2}
                                label="Jumlah"
                                onValueChange={(value, name) => {
                                    setFieldValue(name, value)
                                }}
                            />
                            <small className="form-text text-muted">
                                <b>Cari</b> Selisih Nominal Kurang Dari
                            </small>
                        </div>

                    </div>
                    <div>
                        <button className='btn btn-warning float-right mx-1' onClick={handleSubmit}>
                            Terapkan
                        </button>
                        <button className='btn btn-outline-danger float-right mx-1' onClick={resetForm}>
                            Reset Pencarian
                        </button>
                    </div>

                </form>
            )}
        </Formik>

    );

};

